<template>
  <AdminNavbar />
  <div class="admin-auth-wrapper">
    <div class="auth-card">
      <h2 class="auth-title">Register New Stylist</h2>
      <p class="auth-subtitle">Create a new stylist account and generate a temporary password.</p>

      <p v-if="successMessage" class="success-message">
        {{ successMessage }}
        <!--<br>
        <strong>Temporary Code: {{ tempPassword }}</strong>
        <br>
        *Please note this code before navigating away.-->
      </p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

      <form @submit.prevent="handleRegistration">
        <!-- Full Name -->
        <div class="form-group">
          <label for="full-name">Full Name</label>
          <input type="text" id="full-name" v-model="fullName" required>
        </div>
        
        <!-- Email -->
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" id="email" v-model="email" required>
        </div>

        <!-- Phone Number -->
        <div class="form-group">
          <label for="pnumb">Phone Number</label>
          <input type="text" id="pnumb" v-model="phoneNumber" required>
        </div>

        <!-- Phone Number -->
        <div class="form-group">
          <label for="password">Password</label>
          <input type="password" id="password" v-model="password" required>
        </div>
        
        <button type="submit" class="auth-btn register-btn" :disabled="isLoading">
          {{ isLoading ? 'Registering...' : 'Register Stylist' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AdminNavbar from '@/components/admin/AdminNavbar.vue'

// Base URL for the Flask backend
const API_BASE_URL = 'https://api-afrobraids.inchtechs.com/api/';

export default {
    name: 'RegisterStylist',
    components: {
        AdminNavbar
    },
    data() {
        return {
            fullName: '',
            email: '',
            // specialization: '',
            // isActive: true, // Default to active
            errorMessage: '',
            successMessage: '',
            password: '',
            phoneNumber: '',
            isLoading: false,
        };
    },
    created() {
        const adminInfo = localStorage.getItem("adminUser")
        let user = JSON.parse(adminInfo)
        if(!adminInfo) {
            this.$router.push({ name: 'Authenticate'})
            console.log("Sign in before you can load the component")
        } else if(!user.access_token) {
            this.$router.push({name: 'Authenticate'})
            console.log("Sign in before you can load the component")
        }
    },
    methods: {
        async handleRegistration() {
            this.errorMessage = '';
            this.successMessage = '';
            this.tempPassword = '';
            //this.phoneNumber = ''
            this.isLoading = true;
            console.log("In the handleRegistration function")

            try {
                // 1. Send POST request to the new Flask registration endpoint
                console.log("In the try clause...")
                const response = await axios.post(`${API_BASE_URL}user/create-user`, {
                    full_name: this.fullName,
                    email: this.email,
                    phone_number: this.phoneNumber,
                    password: this.password
                });
                this.successMessage = response.data.message;
                
                // Clear the form fields upon success
                this.fullName = '';
                this.email = '';
                this.specialization = '';
                this.phoneNumber = ''
                this.password = ''
                this.isActive = true;
                console.log("This is after communication with the server")

            } catch (error) {
                console.log("In the error clause")
                // 3. Handle errors (e.g., email already exists, validation failure)
                let message = 'Registration failed. Please try again.';
                if (error.response && error.response.data && error.response.data.error) {
                    message = error.response.data.error;
                }
                this.errorMessage = message;

            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.admin-auth-wrapper {
    min-height: calc(100vh - 60px); /* Adjusting for navbar height */
    background-color: #f4f4f9;
    padding: 30px 15px;
}

.auth-card {
    max-width: 500px;
    margin: 30px auto;
    padding: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    background-color: white;
}

.auth-title {
    color: crimson;
    text-align: center;
    margin-bottom: 5px;
    font-size: 2rem;
    font-weight: 700;
}

.auth-subtitle {
    text-align: center;
    color: #777;
    margin-bottom: 25px;
    font-size: 0.95rem;
}

/* Form Styling */
.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box; 
    transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus {
    border-color: crimson;
    outline: none;
    box-shadow: 0 0 0 3px rgba(220, 20, 60, 0.1);
}

/* Toggle Group for Active Status */
.toggle-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e0e0e0;
    padding: 10px 15px;
    border-radius: 6px;
    background-color: #f9f9f9;
}

.toggle-input {
    appearance: none;
    width: 40px;
    height: 20px;
    background-color: #ccc;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-right: 10px;
}

.toggle-input::after {
    content: '';
    width: 16px;
    height: 16px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.3s;
}

.toggle-input:checked {
    background-color: #28a745; /* Green for active */
}

.toggle-input:checked::after {
    left: 22px;
}

.status-label {
    font-weight: 600;
    color: #555;
    min-width: 60px;
    text-align: right;
}

/* Button Styling */
.auth-btn {
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 6px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, box-shadow 0.3s;
    margin-top: 10px;
}

.register-btn {
    background-color: crimson;
    color: white;
}

.register-btn:hover:not(:disabled) {
    background-color: #c0003c;
    box-shadow: 0 4px 10px rgba(220, 20, 60, 0.3);
}

.register-btn:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
}

/* Messages */
.error-message {
    color: #e74c3c;
    background-color: #fde8e8;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid #e74c3c;
}

.success-message {
    color: #27ae60;
    background-color: #e6f9ed;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid #27ae60;
}
</style>